import { Modal } from "antd";
import { useState } from "react";
import { CheckCircleFilled } from "@ant-design/icons";

const useNotificationCenter = () => {
  const [isShowNotification, setIsShowNotification] = useState(false);
  const showNotification = () => setIsShowNotification(true);
  const hideNotification = () => setIsShowNotification(false);

  const notificationCenter = (
    <Modal
      open={isShowNotification}
      centered
      onClose={hideNotification}
      onCancel={hideNotification}
      footer={false}
      mask={false}
      closable={false}
      rootClassName="notification-center"
      width={400}
      transitionName=""
      maskTransitionName=""
    >
      <div className="flex flex-col justify-center items-center">
        <CheckCircleFilled
          style={{
            color: "#449D98",
            fontSize: 50,
            borderRadius: "100px",
            background: "white",
          }}
        />
        <div className="">คุณได้ทำการเพิ่มสินค้าลงในรถเข็นแล้ว</div>
      </div>
    </Modal>
  );
  return {
    isShowNotification,
    showNotification,
    hideNotification,
    notificationCenter,
  };
};

export default useNotificationCenter;
